import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { fetchApiDataDup } from "../../../../redux/reducers/commonApiSlice";
import { pt_session_details } from "../../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import SearchNButtons from "../../../common-components/SearchNButtons";
import PTTransferDetailsMobile from "./PTTransferDetailsMobile";

const PTTransferDetails = ({ userInfoData, rowData, prevFilters }) => {
  const dispatch = useDispatch();
  const { loadingDup, dataDup, errorDup } = useSelector(
    (state) => state.common
  );

  const [selectedTab, setSelectedTab] = useState(0);
  const iniAllDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniAllDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    subscription_id: rowData?.subscription_id || "",
    trainer_id: selectedTab === 0 ? rowData?.trainer_id || "" : "",
    month: selectedTab === 0 ? prevFilters?.month || "" : "",
    year: selectedTab === 0 ? prevFilters?.year || "" : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
    setFilters((prevs) => ({
      ...prevs,
      trainer_id: index === 0 ? rowData?.trainer_id || "" : "",
      month: index === 0 ? prevFilters?.month || "" : "",
      year: index === 0 ? prevFilters?.year || "" : "",
    }));
  };

  function getDetails(filters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: pt_session_details,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  useEffect(() => {
    if (filters.subscription_id) {
      getDetails(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (
      dataDup?.status &&
      dataDup?.data?.length > 0 &&
      !loadingDup &&
      !errorDup
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: dataDup.data,
        pagination: dataDup?.pagination?.length > 0 ? dataDup.pagination : [],
      }));
    } else {
      setAllDatas(iniAllDatas);
    }
  }, [dataDup, loadingDup, errorDup]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumn = [
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.user_name || "NA"}
          <br />
          <small className="lowercase">
            {row?.user_mobile || ""}
            <br />
            {row?.user_email || ""}
          </small>
        </span>
      ),
    },
    {
      dataField: "trainer_id",
      text: "trainer detail",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.trainer_name || "NA"}
          <br />
          <small className="lowercase">
            {row?.trainer_mobile || ""}
            <br />
            {row?.trainer_email || ""}
          </small>
        </span>
      ),
    },
    {
      dataField: "session_no",
      text: "session No",
      formatter: (cell, row) => (
        <span
          className="tb-data  withPadding borderRdius8"
          style={{
            background: "#FFB200",
            color: "#fff",
            padding: "5px 15px",
          }}
        >
          {row?.session_no || 0}
        </span>
      ),
    },
    {
      dataField: "date",
      text: "date",
      formatter: (cell, row) => (
        <span className="tb-data">{row?.date || "-"}</span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed" || row?.status === "verified"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed" || row?.status === "verified"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <SearchNButtons
        filters={allFilters}
        setFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
      />

      <div className="fullWidthFlexCenter tabsContainer flexStart bgTransParent tmeTabs mt30">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
          <TabList>
            <Tab>Incentive Applicable Sessions Completed</Tab>
            <Tab>All Sessions Completed</Tab>
          </TabList>

          <TabPanel>
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile">
                  <PaymentLinkTable
                    tableData={allDatas.allData}
                    tableColumns={tbColumn}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <PTTransferDetailsMobile
                    tableData={allDatas.allData}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>
              </>
            )}
          </TabPanel>
          <TabPanel>
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile">
                  <PaymentLinkTable
                    tableData={allDatas.allData}
                    tableColumns={tbColumn}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <PTTransferDetailsMobile
                    tableData={allDatas.allData}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                </div>
              </>
            )}
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default PTTransferDetails;
